// @ts-ignore
import SimpleParallax from 'simple-parallax-js/vanilla';

document.addEventListener('DOMContentLoaded', () => {
  new SimpleParallax(document.querySelectorAll('.parallax'), {
    customWrapper: '.parallax-container',
  });
});
